export const adaptModalidadVisita = (modalidadVisitaData) => {
    return {
        id: modalidadVisitaData?.idModalidadVisita,
        displayName: modalidadVisitaData?.nombre,
        name: modalidadVisitaData?.nombre
    }
}

export const adaptModalidadVisitaArray = (
    modalidadVisitas
) => {
    return structuredClone(modalidadVisitas?.allModalidadVisita)
        ?.map(modalidadVisita => adaptModalidadVisita(modalidadVisita));
}